import { useCallback } from 'react';
import { errorLogger } from '../services/errorLogger';

/**
 * Hook for using error logger in React components
 * Usage:
 *   const { logError, logWarning, logInfo } = useErrorLogging();
 *   logError('API request failed', error, { endpoint: '/api/payments' });
 */
export function useErrorLogging() {
  const logError = useCallback(
    (message: string, error?: any, context?: Record<string, any>) => {
      errorLogger.logError(message, error, context);
    },
    []
  );

  const logWarning = useCallback(
    (message: string, context?: Record<string, any>) => {
      errorLogger.logWarning(message, context);
    },
    []
  );

  const logInfo = useCallback(
    (message: string, context?: Record<string, any>) => {
      errorLogger.logInfo(message, context);
    },
    []
  );

  const getLogs = useCallback(() => {
    return errorLogger.getLogs();
  }, []);

  const exportLogs = useCallback(() => {
    errorLogger.exportLogsAsFile();
  }, []);

  const clearLogs = useCallback(() => {
    errorLogger.clearLogs();
  }, []);

  const sendLogs = useCallback(
    (note?: string, userId?: string) => {
      return errorLogger.sendLogsToBackend({ note, userId });
    },
    []
  );

  return {
    logError,
    logWarning,
    logInfo,
    getLogs,
    exportLogs,
    clearLogs,
    sendLogs
  };
}
